import { createContext } from 'react';
import type { ValorSessao } from './sessao';

/**
 * Lote de 19/10 (item 9): o contexto da sessão num módulo sem efeitos (o `sessao.tsx` inicia o i18n ao ser importado).
 * Componente do núcleo que só lê a sessão (o `Formulario`, pelo `useCamposDaTela`) importa daqui e não muda o idioma de
 * quem o importa (os testes de formatação rodam sem a sessão).
 */
export const CtxSessao = createContext<ValorSessao | null>(null);
